module.exports = __webpack_public_path__ + "static/media/my-info-menu-main-active-icon.cd6a069e.svg";